import React from 'react';
import { string, bool, func } from 'prop-types';
import { Link } from 'react-router-dom';

class NavbarBrand extends React.PureComponent {
    static propTypes = {
        path: string.isRequired,
        title: string
    };
    static defaultProps = {
        path: '/',
        title: 'home'
    };
    render() {
        return (
            <Link className="navbar-brand" to={this.props.path}>
                {this.props.children || this.props.title}
            </Link>
        );
    }
}

class NavbarToggle extends React.PureComponent {
    static propTypes = {
        target: string.isRequired,
        expanded: bool.isRequired,
        onToggle: func.isRequired
    };
    static defaultProps = {
        expanded: false
    };
    render() {
        const { target, expanded } = this.props;
        return (
            <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target={target}
                aria-controls={target}
                aria-expanded={expanded}
                aria-label="Toggle navigation"
                onClick={this.props.onToggle}
            >
                <span className="navbar-toggler-icon" />
            </button>
        );
    }
}

class NavbarCollapse extends React.PureComponent {
    static propTypes = {
        targetId: string.isRequired,
        expanded: bool.isRequired
    };

    static defaultProps = {
        expanded: true
    };

    render() {
        const { expanded, targetId } = this.props;
        return (
            <div
                className={`collapse navbar-collapse ${expanded ? 'show' : ''}`}
                id={targetId}
            >
                {this.props.children}
            </div>
        );
    }
}

class Navbar extends React.PureComponent {
    static propTypes = {
        classNames: string.isRequired
    };

    static defaultProps = {
        classNames: 'navbar-light bg-light'
    };

    render() {
        const { classNames } = this.props;
        return (
            <nav className={`navbar navbar-expand-lg ${classNames}`}>
                {this.props.children}
            </nav>
        );
    }
}

Navbar.Brand = NavbarBrand;
Navbar.Toggle = NavbarToggle;
Navbar.Collapse = NavbarCollapse;

export default Navbar;
